export default "__VITE_ASSET__DUj8GKWG__"